const ITEMS = [
  "Tarot Readings",
  "Energy Cleansing",
  "Chakra Balancing",
  "Spiritual Healing",
  "Aura Restoration",
  "Intuitive Guidance",
  "Energy Detox",
];

export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee-section"
      className="relative py-10 border-y border-[#D4AF37]/15 bg-[#130C1E] overflow-hidden"
    >
      <div className="marquee-track">
        {loop.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center">
            <span className="font-serif-display italic text-[#EAE0D5]/90 text-3xl sm:text-5xl px-8">
              {item}
            </span>
            <span className="text-[#D4AF37] text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
